import React from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { Controller, useForm } from 'react-hook-form';
import ErrorMessage from '../../../components/text/ErrorMessage';

interface IEventDoneFormProps {
  onCancel: () => void;
  onSuccess: () => void;
  eventId: string;
  markAsDone: (mileageIn?: string, mileageOut?: string) => void;
}

export const EventDoneForm: React.FunctionComponent<IEventDoneFormProps> = (
  props
) => {
  const { control, handleSubmit, errors } = useForm<IEventMarkAsDoneModel>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });
  const onSubmit = async (data: IEventMarkAsDoneModel) => {
    props.markAsDone(data.mileageIn, data.mileageOut);
  };
  return (
    <div className="container-fluid p-4 popover-style popover-style2 position-relative">
      <form id={'activity-form'} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="font-normal font-weight-semibold mb-2 pb-2">
            Appointment Mark As Done
          </div>
          <div className="form-group font-weight-semibold mb-3">
            <label htmlFor="" className="font-sm text-uppercase">
              Mileage In<span className="text-danger">*</span>
            </label>

            <Controller
              control={control}
              rules={{ required: true }}
              name="mileageIn"
              render={({ onChange, value, name }) => (
                <textarea
                  className="form-control rounded-sm font-weight-semibold"
                  onChange={onChange}
                  style={{ height: '47px' }}
                  name=""
                  id=""
                />
              )}
            />
            {errors.mileageIn && (
              <ErrorMessage> Mileage In is required</ErrorMessage>
            )}
          </div>

          <div className="form-group font-weight-semibold mb-3">
            <label htmlFor="" className="font-sm text-uppercase">
              Mileage Out<span className="text-danger">*</span>
            </label>

            <Controller
              control={control}
              rules={{ required: true }}
              name="mileageOut"
              render={({ onChange, value, name }) => (
                <textarea
                  className="form-control rounded-sm font-weight-semibold"
                  onChange={onChange}
                  style={{ height: '47px' }}
                  name=""
                  id=""
                />
              )}
            />
            {errors.mileageOut && (
              <ErrorMessage> Mileage out is required</ErrorMessage>
            )}
          </div>
          <div className="text-right">
            <button
              onClick={() => {
                if (props.onCancel) {
                  props.onCancel();
                }
              }}
              className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            >
              Cancel
            </button>
            <button
              type="submit"
              form="activity-form"
              className="btn btn-primary py-2 font-weight-semibold font-normal"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export interface IEventMarkAsDoneModel {
  mileageIn: string;
  mileageOut: string;
}
